<template>
    <div class="game_info">
        <van-overlay :show="infoShow">
            <div class="game_info_wrapper">
                <img src="@/assets/images/game/close.png" @click="goback" class="game_info_wrapper_close" />
                <div class="game_info_wrapper_pic">
                    <img src="@/assets/images/game/star.png" v-if="num>1" class="game_info_wrapper_pic_small" />
                    <img src="@/assets/images/game/kong-star.png" v-if="num<2" class="game_info_wrapper_pic_small" />
                    <img src="@/assets/images/game/star.png" class="game_info_wrapper_pic_big" />
                    <img src="@/assets/images/game/star.png" v-if="num>2" class="game_info_wrapper_pic_small" />
                    <img src="@/assets/images/game/kong-star.png" v-if="num<3" class="game_info_wrapper_pic_small" />
                </div>
                <p>{{infoMsg}}</p>
                <div class="game_info_wrapper_button">
                     <div class="game_info_wrapper_button_no" @click.stop="goback">
                         返回关卡
                     </div>
                     <div class="game_info_wrapper_button_yes" @click.stop="next" v-if="!nextFlag" >
                         下一关
                     </div>
                </div>
            </div>
        </van-overlay>
    </div>
</template>
<script>
export default {
    name: 'success-info',
    props:['infoShow','infoMsg','num','nextFlag'],
    data () {
        return {

        }
    },
    methods:{
        next() {
            this.$emit('next');
        },
        goback() {
            this.$emit('goback');
        },
    }
}
</script>
<style lang='scss' scoped>
.van-overlay {
    z-index: 99;
    display: flex;
    justify-content: center;
    align-items: center;
    .game_info_wrapper {
        width: 248px;
        height: 173px;
        background: url(./../../assets/images/game/info.png);
        background-size: cover;
        position: relative;
        .game_info_wrapper_close {
            position: absolute;
            width: 26px;
            height: 26px;
            right: -10px;
            top: -10px;
        }
        .game_info_wrapper_pic {
            width: 182px;
            height: 49px;
            margin-left: 33px;
            margin-top: -26px;
            display: flex;
            justify-content: center;
            .game_info_wrapper_pic_small {
                width: 26px;
                height: 30px;
                margin-top: 15px;
            }
            .game_info_wrapper_pic_big {
                width: 39px;
                height: 45px;
            }
        }
        p {
            font-size: 22px;
            font-family: PingFangSC-Medium, PingFang SC;
            font-weight: 500;
            color: #E7684E;
            text-align: center;
            margin-top: 30px;
        }
        .game_info_wrapper_button {
            display: flex;
            justify-content: center;
            margin-top: 40px;
            .game_info_wrapper_button_no {
                width: 86px;
                height: 31px;
                background: url(./../../assets/images/game/no.png);
                background-size: cover;
                font-size: 16px;
                font-family: PingFangSC-Medium, PingFang SC;
                font-weight: 500;
                color: #FFFFFF;
                line-height: 31px;
                text-shadow: 0px 2px 1px #6381FF;
                text-align: center;
            }
            .game_info_wrapper_button_yes {
                width: 86px;
                height: 31px;
                background: url(./../../assets/images/game/yes.png);
                background-size: cover;
                margin-left: 12px;
                font-size: 16px;
                font-family: PingFangSC-Medium, PingFang SC;
                font-weight: 500;
                color: #FFFFFF;
                line-height: 31px;
                text-shadow: 0px 2px 1px #fe8c62;
                text-align: center;
            }
        }
    }
}

</style>
